module.exports = __webpack_public_path__ + "static/media/lightbulb.03c17612.svg";